export const getTitle = (title) => {
  const titleSuffixValue = document.title.split('| ')[1] || '';
  const titleSuffix = titleSuffixValue ? ` | ${titleSuffixValue}` : '';
  return `${title}${titleSuffix}`;
};



// WEBPACK FOOTER //
// ./src/utils/metaTitleHelper.js